import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ILabelDto, LabelDto } from '../../api/ClientApi';
import { WarehouseClient } from '../../api/Extensions';
import { LabelEntity } from '../reducers/labelReducer';

export const createNewEmptyLabel = createAction('labels/createNewEmptyLabel');
export const createNewArticleLabel = createAction('labels/createNewArticleLabel');
export const clearLabels = createAction('labels/clearLabels');
export const addMultipleArticleLabelToRedux = createAction<LabelDto[]>('labels/addMultipleArticleLabelToRedux');

export const updateLabelTitle = createAction<string>('labels/updateLabelTitle');

export const addNewLabelEntity = createAction<ILabelDto>('labels/addNewLabelEntity');
export const addNewArticleLabelToRedux = createAction<ILabelDto>('labels/addNewArticleLabelToRedux');
export const setLabelEntities = createAction<LabelEntity[]>('labels/setLabelEntities');
export const removeLabelEntity = createAction<number>('labels/removeLabelEntity');

export const setResponseMessage = createAction<string>('labels/setResponseMessage');

export const importArticleLabels = createAsyncThunk<LabelDto[]>(
    'labels/importArticleLabels',
    async (payload, thunkAPI) => {
        return WarehouseClient.getAllArticleLabels();
    },
);
